import "./Home.scss";

import { Dialog, DialogAlignment } from "@itwin/core-react";
import { Button } from "@itwin/itwinui-react";
import { ModelessDialogManager } from "@itwin/appui-react";
import { cInitApp } from "./InitApp";

export class cHome {
  public static showHelp() {
    window.open("./docs/geminai.pdf", "_blank");
  }

  public static refresh() {
    cInitApp.reInitApp();
  }

  public static logout() {
    cInitApp.logout();
  }

  private static handleDialogClose = () => {
    ModelessDialogManager.closeDialog("aboutDialog");
  };

  public static aboutDialog() {
    ModelessDialogManager.openDialog(
      <Dialog
        id={"aboutDialog"}
        opened={true}
        modal={true}
        onClose={cHome.handleDialogClose}
        onEscape={cHome.handleDialogClose}
        resizable={false}
        movable={true}
        inset={true}
        hideHeader={true}
        width={400}
        height={220}
        alignment={DialogAlignment.Center}
      >
        <img src="./image/geminai_about.png" width="375px" />
        <div className="about-footer">
          <Button styleType="cta" onClick={cHome.handleDialogClose}>
            Close
          </Button>
        </div>
      </Dialog>,
      "aboutDialog"
    );
  }
}
